import React from 'react';
import { Check, Target, Users, TrendingUp, Calendar, BookOpen } from 'lucide-react';
import { Button } from './Button';
export function ProductReveal() {
  return <section className="py-20 px-4 bg-gradient-to-b from-[#0F1F3D] to-[#0A1628] border-t border-[#C6F432]/20" data-id="element-283">
      <div className="max-w-5xl mx-auto" data-id="element-284">
        <div className="text-center mb-16" data-id="element-285">
          <h2 className="text-5xl md:text-7xl font-anton text-[#C6F432] mb-4" data-id="element-286">
            🎾 MEGAPACK PADEL RESUELTO™
          </h2>
          <p className="text-2xl md:text-3xl text-white font-bold mb-8" data-id="element-287">
            El sistema que cambia todo
          </p>

          <div className="flex flex-wrap justify-center gap-6 mb-12" data-id="element-288">
            <div className="flex items-center gap-2 text-lg font-medium" data-id="element-289">
              <Check className="text-[#C6F432]" data-id="element-290" /> +300 páginas estructuradas
            </div>
            <div className="flex items-center gap-2 text-lg font-medium" data-id="element-291">
              <Check className="text-[#C6F432]" data-id="element-292" /> 60+ clases listas
            </div>
            <div className="flex items-center gap-2 text-lg font-medium" data-id="element-293">
              <Check className="text-[#C6F432]" data-id="element-294" /> Funciona desde hoy
            </div>
          </div>

          <div className="mb-16" data-id="element-295">
            <h3 className="text-gray-400 uppercase tracking-widest text-sm mb-4" data-id="element-296">
              Niveles incluidos
            </h3>
            <div className="flex justify-center gap-4 flex-wrap" data-id="element-297">
              <span className="bg-[#0A1628] border border-[#C6F432]/50 text-white px-6 py-2 rounded-full font-bold" data-id="element-298">
                Principiante
              </span>
              <span className="bg-[#0A1628] border border-[#C6F432]/50 text-white px-6 py-2 rounded-full font-bold" data-id="element-299">
                Intermedio
              </span>
              <span className="bg-[#0A1628] border border-[#C6F432]/50 text-white px-6 py-2 rounded-full font-bold" data-id="element-300">
                Avanzado
              </span>
            </div>
          </div>
        </div>

        <div className="bg-[#0A1628] border border-white/10 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-301">
          <h3 className="text-3xl font-anton text-center mb-10" data-id="element-302">
            Vas a dominar:
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-8" data-id="element-303">
            <div className="flex flex-col items-center text-center gap-3" data-id="element-304">
              <div className="bg-[#0F1F3D] p-4 rounded-full text-[#C6F432]" data-id="element-305">
                <BookOpen size={32} data-id="element-306" />
              </div>
              <span className="font-bold text-lg" data-id="element-307">Fundamentos</span>
            </div>
            <div className="flex flex-col items-center text-center gap-3" data-id="element-308">
              <div className="bg-[#0F1F3D] p-4 rounded-full text-[#C6F432]" data-id="element-309">
                <Target size={32} data-id="element-310" />
              </div>
              <span className="font-bold text-lg" data-id="element-311">Técnica</span>
            </div>
            <div className="flex flex-col items-center text-center gap-3" data-id="element-312">
              <div className="bg-[#0F1F3D] p-4 rounded-full text-[#C6F432]" data-id="element-313">
                <Check size={32} data-id="element-314" />
              </div>
              <span className="font-bold text-lg" data-id="element-315">Corrección</span>
            </div>
            <div className="flex flex-col items-center text-center gap-3" data-id="element-316">
              <div className="bg-[#0F1F3D] p-4 rounded-full text-[#C6F432]" data-id="element-317">
                <TrendingUp size={32} data-id="element-318" />
              </div>
              <span className="font-bold text-lg" data-id="element-319">Progresión</span>
            </div>
            <div className="flex flex-col items-center text-center gap-3" data-id="element-320">
              <div className="bg-[#0F1F3D] p-4 rounded-full text-[#C6F432]" data-id="element-321">
                <Calendar size={32} data-id="element-322" />
              </div>
              <span className="font-bold text-lg" data-id="element-323">Planificación</span>
            </div>
            <div className="flex flex-col items-center text-center gap-3" data-id="element-324">
              <div className="bg-[#0F1F3D] p-4 rounded-full text-[#C6F432]" data-id="element-325">
                <Users size={32} data-id="element-326" />
              </div>
              <span className="font-bold text-lg" data-id="element-327">
                Clases grupales e individuales
              </span>
            </div>
          </div>

          <div className="mt-12 text-center" data-id="element-328">
            <Button className="text-lg" data-id="element-329">SÍ, QUIERO EL SISTEMA AHORA</Button>
          </div>
        </div>
      </div>
    </section>;
}